var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDovetailDark = function SvgDovetailDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 256 293"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dovetail-dark_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m256 182.857-64 36.572v-73.143l-64-36.974 64-36.17 64 36.572zm-128.009-73.143-64 36.572V73.143L0 36.57 64 0l63.991 36.571zm0 146.286-64 36.571.009-73.142-64-36.572 63.99-36.571 64.001 36.571z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dovetail-dark_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h256v293H0z"
  })))));
};
export default SvgDovetailDark;